import React from 'react';
import MyNavbar from '../../../components/customer/MyNavbar';
import HeroSection from '../../../screens/customer/home/Herosection';
import SmartPlanning from "../../../screens/customer/home/SmartPlanning";
import ServicesSection from '../../../screens/customer/home/ServicesSection';
import VedioSection from '../../../screens/customer/home/VedioSection';
import WeddingProgram from '../../../screens/customer/home/WeddingProgram';
import TeamSection from '../../../screens/customer/home/TeamSection';
import TestimonialSection from '../../../screens/customer/home/TestimonialSection';
import ReservationForm from '../../../screens/customer/home/ReservationForm';
import EventPlanning from '../../../screens/customer/home/EventPlanning';
import Footer from '../../../components/customer/Footer';

const Home = () => {
  return (
    <>
      <MyNavbar />
      <HeroSection />
      <SmartPlanning />
      <VedioSection />
      <ServicesSection />
      <WeddingProgram />
       <EventPlanning />
      <TeamSection />
      <TestimonialSection />
      <ReservationForm />
      <Footer />
    </>
  );
}
export default Home;